const HTTP_PROTOCOL_PATTERN = /^https?:\/\//i;
const DOMAIN_PATTERN =
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/i;
const DOMAIN_URL_PATTERN =
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})(?::\d{1,5})?(?:[/?#].*)?$/i;

export function normalizeUrl(input: string): string | null {
  const trimmedInput = input.trim();

  if (!trimmedInput || /\s/.test(trimmedInput)) return null;

  const hasHttpProtocol = HTTP_PROTOCOL_PATTERN.test(trimmedInput);
  if (!hasHttpProtocol && !DOMAIN_URL_PATTERN.test(trimmedInput)) return null;

  try {
    const url = new URL(
      hasHttpProtocol ? trimmedInput : `https://${trimmedInput}`
    );

    if (!DOMAIN_PATTERN.test(url.hostname)) return null;

    return url.toString();
  } catch {
    return null;
  }
}
